import { parseDataFormula } from '@shared/components/formula/utils/formula-modelo.util';
import { selecionarFormulasPorCriterio } from '@shared/components/formula/utils/formula-contexto.util';
import { Component, Inject, OnInit, inject } from '@angular/core';
import { LookupService } from '@shared/services/apis/produto/produto-lookup.service';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { map, catchError, of } from 'rxjs';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { AlertCardComponent } from '@shared/components/alert-card/alert-card.component';
import { ConfirmModalComponent } from '@shared/components/confirm-modal/confirm-modal.component';
import { EmptyStateComponent } from '@shared/components/empty-state/empty-state.component';
import { WizardStepsComponent } from '@shared/components/wizard-steps/wizard-steps.component';
import { IpiTributoObservacoesSectionComponent } from '../sections/tributo-observacoes-section/tributo-observacoes-section.component';
import { IpiTributoObservacoesFiscoSectionComponent } from '../sections/tributo-observacoes-fisco-section/tributo-observacoes-fisco-section.component';
import { IpiTributoRegraSectionComponent, MAPA_CAMPOS_IPI_NATUREZA } from '../sections/tributo-regra-section/tributo-regra-section.component';
import { FormulaEditorDialogComponent, FormulaEditorDialogData, FormulaEditorDialogResult } from '@shared/components/formula/formula-editor-dialog/formula-editor-dialog.component';
import { SelectPesquisavelComponent } from '@shared/components/select-pesquisavel/select-pesquisavel.component';
import { SelectPesquisavelService } from '@shared/components/select-pesquisavel/select-pesquisavel.service';
import {
    PesquisaCodigoTributacaoModalComponent,
    PesquisaCodigoTributacaoModalData,
    PesquisaCodigoTributacaoModalResult,
} from '@shared/components/pesquisa-codigo-tributacao-modal/pesquisa-codigo-tributacao-modal.component';
import { AlertService, AlertType } from '@shared/services/alert.service';
import { mensagemNcmRedundante } from '../../../natureza-operacao-excecao-escopo.util';
import { MaskService } from '@shared/services/mask.service';
import { VariavelStruct } from '@shared/services/structs/formula/variavel.struct';
import { FormulaCatalogoItemStruct } from '@shared/services/structs/formula/formula-catalogo-item.struct';
import { FormulaCatalogoService } from '@shared/services/apis/motor-fiscal/formula-catalogo.service';
import {
    aplicarObrigatoriedadeIndicadores,
    controlesDasRegrasEntreCampos,
    lerIndicadoresCst,
} from '@shared/constants/motor-fiscal/indicadores-campos.util';
import {
    NaturezaOperacaoIpiExcecaoEscopoStruct,
} from '@shared/services/structs/motor-fiscal/natureza-operacao-ipi-excecao-escopo.struct';
import {
    NaturezaOperacaoIpiExcecaoStruct,
} from '@shared/services/structs/motor-fiscal/natureza-operacao-ipi-excecao.struct';
import {
    FormulaItemStruct,
} from '@shared/services/structs/formula/formula-item.struct';
import { CstIpiStruct } from '@shared/services/structs/motor-fiscal/cst-ipi.struct';
import { TipoFormulaEnum } from '@shared/enums/formula/tipo-formula.enum';
import { environment } from '../../../../../../../../environments/environment';
import { aplicarRotuloContraparte, iconeEscopoGrupo, iconeTipoEscopo } from '../../../escopo-contraparte.util';
import { TipoEscopoEnum } from '@shared/enums/motor-fiscal/tipo-escopo.enum';
import { TipoGrupoEscopoEnum } from '@shared/enums/motor-fiscal/tipo-grupo-escopo.enum';
import type { TipoOperacaoEnum } from '@shared/enums/motor-fiscal/tipo-operacao.enum';
import { MotorFiscalLookupService } from '@shared/services/apis/motor-fiscal/motor-fiscal-lookup.service';
import { UnidadeFederativaService } from '@shared/services/apis/usuario/unidade-federativa.service';
import { ModalidadeBcOption } from '@shared/services/structs/motor-fiscal/modalidade-bc-option.struct';
import { planejarTrocaCodigoFormulas } from '@shared/components/formula/utils/troca-codigo-formulas.util';

export interface ExcecaoWizardDialogData {
    idNaturezaOperacao: number;
    idExcecao?: number | null;
    excecaoData?: NaturezaOperacaoIpiExcecaoStruct | null;
    codigoTributos: CstIpiStruct[];
    variaveis: VariavelStruct[];
    formulas: FormulaCatalogoItemStruct[];
    tipoOperacao: TipoOperacaoEnum;
    modalidadesBcSt: ModalidadeBcOption[];
}

export interface ExcecaoWizardDialogResult {
    salvo: boolean;
    excecao?: NaturezaOperacaoIpiExcecaoStruct;
    idExcecao?: number | null;
}

export interface EscopoGrupo {
    tipo: TipoEscopoEnum;
    label: string;
    grupo: TipoGrupoEscopoEnum;
    labelGrupo: string;
    placeholder: string;
    valores: { codigo: string; descricao: string; sku?: string }[];
    valorNovo: string;
    tempControl?: FormControl;
    pendingItem?: any;
}

export const GRUPOS_ESCOPO_DEF = [
    {
        grupo: TipoGrupoEscopoEnum.Territoriais,
        labelGrupo: 'Territoriais',
        tipos: [
            { tipo: TipoEscopoEnum.UfOrigem,  label: 'UF de Origem', placeholder: '' },
            { tipo: TipoEscopoEnum.UfDestino, label: 'UF de Destino', placeholder: '' },
        ],
    },
    {
        grupo: TipoGrupoEscopoEnum.Produto,
        labelGrupo: 'Produto',
        tipos: [
            { tipo: TipoEscopoEnum.Produto,          label: 'Produto',  placeholder: '' },
            { tipo: TipoEscopoEnum.Ncm,              label: 'NCM',      placeholder: '' },
            { tipo: TipoEscopoEnum.Cest,             label: 'CEST',     placeholder: '' },
            { tipo: TipoEscopoEnum.OrigemMercadoria, label: 'Origem da Mercadoria',   placeholder: '' },
            { tipo: TipoEscopoEnum.TipoItem,         label: 'Tipo de Item', placeholder: '' },
        ],
    },
    {
        grupo: TipoGrupoEscopoEnum.Cliente,
        labelGrupo: 'Cliente',
        tipos: [
            { tipo: TipoEscopoEnum.IndicadorInscricaoEstadual, label: 'Tipo Contribuinte', placeholder: '' },
            { tipo: TipoEscopoEnum.RegimeTrib,     label: 'Regime Tributário do Cliente',   placeholder: '' },
            { tipo: TipoEscopoEnum.TipoTributario, label: 'Tipo Tributário do Cliente', placeholder: '' },
        ],
    },
];

@Component({
    selector: 'app-ipi-excecao-wizard-dialog',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatMenuModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        AlertCardComponent,
        EmptyStateComponent,
        WizardStepsComponent,
        IpiTributoObservacoesSectionComponent,
        IpiTributoObservacoesFiscoSectionComponent,
        IpiTributoRegraSectionComponent,
        SelectPesquisavelComponent,
        NgxMaskDirective,
    ],
    providers: [provideNgxMask()],
    templateUrl: './excecao-wizard-dialog.component.html',
    styleUrl: './excecao-wizard-dialog.component.css',
})
export class IpiExcecaoWizardDialogComponent implements OnInit {
    public readonly iconeEscopoGrupo = iconeEscopoGrupo;
    public readonly iconeTipoEscopo = iconeTipoEscopo;
    public readonly TipoEscopoEnum = TipoEscopoEnum;
    public readonly masks = MaskService.getMasks();
    /** Comprimentos de NCM aceitos nas exceções (capítulo/posição/subposição/item/subitem). */
    private readonly ncmComprimentosValidos = [2, 4, 5, 6, 7, 8];

    public passo = 0;
    public salvando = false;

    public readonly passos = ['Escopo', 'Vigência', 'Parâmetros'];
    public readonly descricoesPassos = [
        'Defina quando esta exceção se aplica. É obrigatório adicionar ao menos um escopo com valor.',
        'Define quando esta exceção estará ativa. A data de início é obrigatória. Sem data de fim, a exceção é permanente.',
        'Configure as alíquotas, CST, reduções e informações complementares para esta exceção.'
    ];

    public get gruposEscopoDefinicao() { return aplicarRotuloContraparte(GRUPOS_ESCOPO_DEF, this.data.tipoOperacao, this.tiposEscopoLabels); }
    public origemOpcoes: { id: string; codigo: string; descricao: string }[] = [];
    public tipoItemOpcoes: { id: string; codigo: string; descricao: string }[] = [];
    public ufOfflineList: { id: string; descricao: string; descricaoExibicao: string }[] = [];
    public tiposEscopoLabels: Record<number, string> = {};

    public gruposEscopo: EscopoGrupo[] = [];
    private readonly produtoLookup = inject(LookupService);

    // Ids sempre em texto (String) para casar com o FormControl<string[]> dos selects multi-seleção
    // (ver reconstruirGrupos) — o Motor Fiscal também compara valoresEscopo como string.
    public listaRegimeTributario: { id: string; descricao: string }[] = [];
    public listaIndicadorInscricaoEstadual: { id: string; descricao: string }[] = [];
    public listaTipoTributario: { id: string; descricao: string }[] = [];

    public readonly ncmLookupUrl = environment.urlApiMotorFiscal + 'Lookup/ncm';
    public readonly cestLookupUrl = environment.urlApiMotorFiscal + 'Lookup/cest';
    public readonly produtoLookupUrl = environment.urlApiProduto + 'Lookup/listProdutoSelect';

    public step2 = new FormGroup({
        dataVigenciaInicio: new FormControl<Date | null>(null),
        dataVigenciaFim:    new FormControl<Date | null>(null),
    });
    public dataVigenciaInicio: Date | null = null;
    public dataVigenciaFim: Date | null = null;

    public step3 = new FormGroup({
        cstIpi: new FormControl<string | null>(null, Validators.required),
        codigoEnquadramentoIpi: new FormControl<string | null>(null),
        pIpi:         new FormControl<number | null>(null),
        vUnid:        new FormControl<number | null>(null),
        observacao:   new FormControl<string | null>(null),
        observacaoFisco: new FormControl<string | null>(null),
    });

    /** Estado das fórmulas personalizadas/modelo desta exceção (mesma estrutura da aba SN). */
    public estadosFormulas: FormulaItemStruct[] = [];
    private codigoTributoAnterior: string | null = null;
    private restaurandoCodigoTributo = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ExcecaoWizardDialogData,
        private dialogRef: MatDialogRef<IpiExcecaoWizardDialogComponent>,
        private matDialog: MatDialog,
        private alertService: AlertService,
        private selectPesquisavelService: SelectPesquisavelService,
        private motorFiscalLookupService: MotorFiscalLookupService,
        private formulaCatalogoService: FormulaCatalogoService,
        private ufService: UnidadeFederativaService,
    ) {}

    ngOnInit(): void {
        this.dataVigenciaInicio = new Date();
        this.sincronizarStep2Vigencia();

        this.motorFiscalLookupService.getNaturezaOperacaoExcecaoLookup().subscribe(resp => {
            this.listaRegimeTributario = (resp.regimesTributarios ?? []).map(x => ({ id: String(x.id), descricao: x.descricao }));
            this.listaIndicadorInscricaoEstadual = (resp.indicadoresInscricaoEstadual ?? []).map(x => ({ id: String(x.id), descricao: x.descricao }));
            this.listaTipoTributario = (resp.tiposTributario ?? []).map(x => ({ id: String(x.id), descricao: x.descricao }));
            this.atualizarDescricoesEscopo(TipoEscopoEnum.RegimeTrib, this.listaRegimeTributario);
            this.atualizarDescricoesEscopo(TipoEscopoEnum.IndicadorInscricaoEstadual, this.listaIndicadorInscricaoEstadual);
            this.atualizarDescricoesEscopo(TipoEscopoEnum.TipoTributario, this.listaTipoTributario);
        });

        // UF: grava o id da unidade federativa (não mais a sigla), para casar com o Motor Fiscal.
        this.ufService.getUnidadesFederativas().subscribe(list => {
            this.ufOfflineList = list.map(u => ({ id: String(u.idUnidadeFederativa), descricao: u.descricao, descricaoExibicao: u.descricaoExibicao }));
            this.atualizarDescricoesEscopo(TipoEscopoEnum.UfOrigem, this.ufOfflineList);
            this.atualizarDescricoesEscopo(TipoEscopoEnum.UfDestino, this.ufOfflineList);
        });

        this.motorFiscalLookupService.getTiposEscopo().subscribe(list => {
            this.tiposEscopoLabels = list.reduce((acc, item) => {
                acc[item.id] = item.descricao;
                return acc;
            }, {} as Record<number, string>);
        });

        this.motorFiscalLookupService.getLookup().subscribe(resp => {
            if (!resp.isError) {
                this.origemOpcoes = (resp.listaOrigemMercadoria ?? []).map(x => ({ id: String(x.id), codigo: x.codigo, descricao: x.descricao }));
                this.tipoItemOpcoes = (resp.listaTipoItemSped ?? []).map(x => ({ id: String(x.id), codigo: x.codigo, descricao: x.descricao }));
                this.atualizarDescricoesEscopo(TipoEscopoEnum.OrigemMercadoria, this.origemOpcoes);
                this.atualizarDescricoesEscopo(TipoEscopoEnum.TipoItem, this.tipoItemOpcoes);
            }
        });

        this.gruposEscopo = this.reconstruirGrupos(this.data.excecaoData?.escopos ?? []);
        this.atualizarDescricoesEscopo(TipoEscopoEnum.IndicadorInscricaoEstadual, this.listaIndicadorInscricaoEstadual);
        this.atualizarDescricoesEscopo(TipoEscopoEnum.RegimeTrib, this.listaRegimeTributario);
        this.atualizarDescricoesEscopo(TipoEscopoEnum.TipoTributario, this.listaTipoTributario);

        if (this.data.excecaoData) {
            const d = this.data.excecaoData;
            // "yyyy-MM-dd" é o dia da empresa: ler como data local (new Date() leria UTC e recuaria um dia).
            this.dataVigenciaInicio = parseDataFormula(d.dataVigenciaInicio);
            this.dataVigenciaFim = parseDataFormula(d.dataVigenciaFim);
            this.sincronizarStep2Vigencia();
            this.step3.patchValue({
                cstIpi: d.cstIpi ?? null,
                codigoEnquadramentoIpi: d.codigoEnquadramentoIpi ?? null,
                pIpi:         d.pIpi ?? null,
                vUnid:        d.vUnid ?? null,
                observacao:   d.observacao ?? null,
                observacaoFisco: d.observacaoFisco ?? null,
            });
            this.resolverProdutosEscopoBadges();
            this.estadosFormulas = (d.formulas ?? []).map(f => ({
                chaveFormula:      f.chaveFormula,
                tipo:               f.tipo,
                chaveFormulaModelo:       f.chaveFormulaModelo ?? null,
                expressao:          f.expressao ?? null,
                tipoArredondamento: f.tipoArredondamento ?? null,
                casasDecimais:       f.casasDecimais ?? null,
                dataVigenciaInicio:     f.dataVigenciaInicio ?? null,
                dataVigenciaFim:        f.dataVigenciaFim ?? null,
            }));
        }

        this.codigoTributoAnterior = this.cstIpiValue;
        this.step3.get('cstIpi')?.valueChanges.subscribe(novoCodigo => {
            this.sincronizarObrigatoriedade();
            this.confirmarTrocaCodigoTributo(novoCodigo);
        });
        controlesDasRegrasEntreCampos(MAPA_CAMPOS_IPI_NATUREZA).forEach(nome =>
            this.step3.get(nome)?.valueChanges.subscribe(() => this.sincronizarObrigatoriedade()));
        this.sincronizarObrigatoriedade();
    }

    /** Campos do código da exceção, pelo indicador do catálogo. */
    private sincronizarObrigatoriedade(): void {
        const codigo = this.step3.get('cstIpi')?.value;
        const indicadores = codigo ? lerIndicadoresCst(this.data.codigoTributos.find(c => c.codigo === codigo)?.indicadores) : null;
        aplicarObrigatoriedadeIndicadores(this.step3, indicadores, MAPA_CAMPOS_IPI_NATUREZA);
    }

    public get isEditMode(): boolean {
        return !!this.data.idExcecao;
    }

    public get cstIpiValue(): string | null {
        return this.step3.get('cstIpi')?.value ?? null;
    }

    /** Fórmulas do catálogo aplicáveis ao código de tributo da exceção. */
    public get formulasParaCodigoTributo(): FormulaCatalogoItemStruct[] {
        return this.obterFormulasParaCodigo(this.cstIpiValue);
    }

    private obterFormulasParaCodigo(codigo: string | null): FormulaCatalogoItemStruct[] {
        if (!codigo) return this.data.formulas;
        return selecionarFormulasPorCriterio(this.data.formulas, 'cst_ipi', codigo);
    }

    private confirmarTrocaCodigoTributo(novoCodigo: string | null): void {
        if (this.restaurandoCodigoTributo || novoCodigo === this.codigoTributoAnterior) return;
        const plano = planejarTrocaCodigoFormulas(
            this.estadosFormulas,
            this.obterFormulasParaCodigo(this.codigoTributoAnterior),
            this.obterFormulasParaCodigo(novoCodigo),
            {
                observacao: this.step3.get('observacao')?.value,
                observacaoFisco: this.step3.get('observacaoFisco')?.value,
            });
        if (plano.estadosParaRestaurar.length === 0 && plano.variaveisPendentes.length === 0) {
            this.codigoTributoAnterior = novoCodigo;
            return;
        }
        const partes = [
            plano.estadosParaRestaurar.length > 0 ? `restaurará ${plano.estadosParaRestaurar.length} configuraç${plano.estadosParaRestaurar.length === 1 ? 'ão' : 'ões'} de fórmulas` : null,
            plano.variaveisPendentes.length > 0 ? `deixará pendentes as variáveis [${plano.variaveisPendentes.map(nome => `{${nome}}`).join(', ')}] nas observações` : null,
        ].filter(Boolean).join(' e ');
        this.matDialog.open(ConfirmModalComponent, {
            data: { title: 'Confirmar troca de CST', description: `A troca para CST ${novoCodigo ?? 'não informado'} ${partes}. Deseja continuar?`, buttonConfirm: 'Continuar', buttonClose: 'Cancelar' },
        }).afterClosed().subscribe(result => {
            if (!result?.confirm) {
                this.restaurandoCodigoTributo = true;
                this.step3.get('cstIpi')?.setValue(this.codigoTributoAnterior, { emitEvent: false });
                this.restaurandoCodigoTributo = false;
                this.sincronizarObrigatoriedade();
                return;
            }
            this.estadosFormulas = this.estadosFormulas.filter(estado => !plano.estadosParaRestaurar.includes(estado));
            Object.entries(plano.observacoes).forEach(([campo, valor]) => this.step3.get(campo)?.setValue(valor));
            this.codigoTributoAnterior = novoCodigo;
        });
    }

    public get personalizadasCount(): number {
        return this.estadosFormulas.filter(e => e.tipo === TipoFormulaEnum.Personalizada).length;
    }

    /** Abre o editor de fórmulas para personalizar/escolher modelos nesta exceção. */
    public abrirEditorFormulas(): void {
        const ct = this.data.codigoTributos.find(c => c.codigo === this.cstIpiValue);
        const data: FormulaEditorDialogData = {
            titulo: ['IPI', this.cstIpiValue, ct?.descricao].filter(Boolean).join(' - '),
            formulas: this.formulasParaCodigoTributo.map(formula => ({
                ...formula,
                variaveis: (formula.variaveisPermitidas ?? formula.variaveis),
            })),
            estadosIniciais: this.estadosFormulas,
            estadosFormulasAgregados: this.estadosFormulas,
            contextoRaiz: 'natureza-operacao',
            validarPersonalizacoes: request => this.formulaCatalogoService.validarPersonalizacoes(request),
        };

        const ref = this.matDialog.open(FormulaEditorDialogComponent, {
            width: '900px',
            maxWidth: '96vw',
            maxHeight: '92vh',
            data,
        });

        ref.afterClosed().subscribe((result: FormulaEditorDialogResult | null) => {
            if (result) {
                this.estadosFormulas = result.formulas;
            }
        });
    }

    public get vigenciaInicioValue(): Date | null {
        return this.dataVigenciaInicio;
    }

    public get vigenciaFimValue(): Date | null {
        return this.dataVigenciaFim;
    }

    // ── Escopo helpers ────────────────────────────────────────────────

    public grupoTemValor(g: EscopoGrupo, codigo: string): boolean {
        return g.valores.some(v => v.codigo === codigo);
    }

    public onSelectChange(g: EscopoGrupo, valor: string, descricao: string): void {
        if (!valor || this.grupoTemValor(g, valor)) return;
        g.valores.push({ codigo: valor, descricao });
        g.valorNovo = '';
    }

    public removerValorGrupo(g: EscopoGrupo, v: { codigo: string; descricao: string }): void {
        g.valores = g.valores.filter(x => x !== v);
    }

    public onSelectPesquisavelChange(g: EscopoGrupo, item: any): void {
        g.pendingItem = item;
    }

    public adicionarPendingItem(g: EscopoGrupo): void {
        const item = g.pendingItem;
        if (!item) return;

        let codigo: string;
        let descricao: string;
        let sku: string | undefined;

        if (g.tipo === TipoEscopoEnum.Produto) {
            codigo = String(item.idProduto ?? item.id);
            descricao = item.descricao ?? item.nome ?? codigo;
            sku = item.codigoSku ?? '';
        } else if (g.tipo === TipoEscopoEnum.RegimeTrib || g.tipo === TipoEscopoEnum.TipoTributario) {
            codigo = String(item.id);
            descricao = item.descricao;
        } else {
            return;
        }

        if (!this.grupoTemValor(g, codigo)) {
            g.valores.push({ codigo, descricao, sku });
        }
        g.pendingItem = null;
        g.tempControl?.setValue(null, { emitEvent: false });
    }

    /** Retorna o texto exibido no select; produto preserva SKU quando disponível. */
    public badgeLabel(v: { codigo: string; descricao: string; sku?: string }): string {
        // Produto: exibe "SKU - Nome" (ou só o nome quando não houver SKU), nunca o id interno.
        if (v.sku !== undefined) {
            const sku = v.sku.trim();
            const nome = (v.descricao ?? '').trim();
            if (sku && nome) return `${sku} - ${nome}`;
            return sku || nome || v.codigo;
        }
        if (!v.descricao || v.descricao === v.codigo) return v.codigo;
        if (v.descricao.startsWith(v.codigo)) return v.descricao;
        return v.descricao;
    }

    // ── NCM / CEST ────────────────────────────────────────────────────

    public onNcmKeydown(event: KeyboardEvent): void {
        this.onCodigoKeydown(event);
    }

    public onCestKeydown(event: KeyboardEvent): void {
        this.onCodigoKeydown(event);
    }

    /** Bloqueia caracteres não numéricos. O tamanho e o ponto são controlados pelo ngx-mask. */
    private onCodigoKeydown(event: KeyboardEvent): void {
        const allowed = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
        const isShortcut = (event.ctrlKey || event.metaKey) && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase());
        if (allowed.includes(event.key) || isShortcut) return;
        if (!/^\d$/.test(event.key)) { event.preventDefault(); }
    }

    public adicionarNcmManual(g: EscopoGrupo): void {
        const codigo = (g.valorNovo ?? '').replace(/\D/g, '');
        if (!this.ncmComprimentosValidos.includes(codigo.length)) {
            this.alertService.show('Atenção', 'O NCM deve ter 2, 4, 5, 6, 7 ou 8 dígitos (capítulo, posição, subposição, item ou subitem).', AlertType.warning);
            return;
        }
        const mensagemRedundancia = mensagemNcmRedundante(codigo, g.valores.map(v => v.codigo), c => this.formatNcm(c));
        if (mensagemRedundancia) {
            this.alertService.show('NCM redundante', mensagemRedundancia, AlertType.warning);
            return;
        }
        if (!this.grupoTemValor(g, codigo)) {
            g.valores.push({ codigo, descricao: codigo });
        }
        g.valorNovo = '';
    }

    public adicionarCestManual(g: EscopoGrupo): void {
        const codigo = (g.valorNovo ?? '').replace(/\D/g, '');
        if (codigo.length !== 7) {
            this.alertService.show('Atenção', 'O CEST deve ter exatamente 7 dígitos.', AlertType.warning);
            return;
        }
        if (!this.grupoTemValor(g, codigo)) {
            g.valores.push({ codigo, descricao: codigo });
        }
        g.valorNovo = '';
    }

    /**
     * Formata um NCM (parcial ou completo) no agrupamento 4/2/2, mantendo os 4 primeiros dígitos
     * sem pontuação. Ex: "12"→"12"; "1234"→"1234"; "12345"→"1234.5"; "123456"→"1234.56";
     * "1234567"→"1234.56.7"; "12345678"→"1234.56.78".
     */
    public formatNcm(codigo: string): string {
        const d = (codigo || '').replace(/\D/g, '');
        if (d.length <= 4) return d;
        if (d.length <= 6) return `${d.slice(0, 4)}.${d.slice(4)}`;
        return `${d.slice(0, 4)}.${d.slice(4, 6)}.${d.slice(6)}`;
    }

    /** Formata um CEST de 7 dígitos no padrão 00.000.00. */
    public formatCest(codigo: string): string {
        const d = (codigo || '').replace(/\D/g, '');
        if (d.length !== 7) return d;
        return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5)}`;
    }

    public pesquisarNcm(g: EscopoGrupo): void {
        const dialogRef = this.matDialog.open(PesquisaCodigoTributacaoModalComponent, {
            width: '700px',
            maxHeight: '85vh',
            panelClass: 'pesquisa-codigo-tributacao-dialog',
            data: {
                titulo: 'Pesquisar NCM',
                buscarFn: (pesquisa: string) =>
                    this.selectPesquisavelService.getSelectValues<any>(this.ncmLookupUrl, pesquisa).pipe(
                        map(list => ({
                            isError: false,
                            itens: list.map((i: any) => ({ codigo: this.formatNcm(String(i.codigo ?? '')), descricao: i.descricao })),
                        })),
                        catchError(() => of({ isError: true, itens: [] })),
                    ),
                permitirManual: false,
                registrosIniciais: 20,
            } as PesquisaCodigoTributacaoModalData,
        });
        dialogRef.afterClosed().subscribe((result: PesquisaCodigoTributacaoModalResult | null) => {
            if (!result?.selecionado) return;
            const codigo = result.selecionado.codigo.replace(/\D/g, '');
            const mensagemRedundancia = mensagemNcmRedundante(codigo, g.valores.map(v => v.codigo), c => this.formatNcm(c));
            if (mensagemRedundancia) {
                this.alertService.show('NCM redundante', mensagemRedundancia, AlertType.warning);
                return;
            }
            if (!this.grupoTemValor(g, codigo)) {
                g.valores.push({ codigo, descricao: codigo });
            }
        });
    }

    public pesquisarCest(g: EscopoGrupo): void {
        const dialogRef = this.matDialog.open(PesquisaCodigoTributacaoModalComponent, {
            width: '700px',
            maxHeight: '85vh',
            panelClass: 'pesquisa-codigo-tributacao-dialog',
            data: {
                titulo: 'Pesquisar CEST',
                buscarFn: (pesquisa: string) =>
                    this.selectPesquisavelService.getSelectValues<any>(this.cestLookupUrl, pesquisa).pipe(
                        map(list => ({
                            isError: false,
                            itens: list.map((i: any) => ({ codigo: String(i.codigo ?? ''), descricao: i.descricao })),
                        })),
                        catchError(() => of({ isError: true, itens: [] })),
                    ),
                permitirManual: false,
                registrosIniciais: 20,
            } as PesquisaCodigoTributacaoModalData,
        });
        dialogRef.afterClosed().subscribe((result: PesquisaCodigoTributacaoModalResult | null) => {
            if (!result?.selecionado) return;
            const codigo = result.selecionado.codigo.replace(/\D/g, '');
            if (!this.grupoTemValor(g, codigo)) {
                g.valores.push({ codigo, descricao: codigo });
            }
        });
    }

    // ── Navegação ─────────────────────────────────────────────────────

    public avancar(): void {
        if (this.passo === 0) {
            const temEscopoValido = this.gruposEscopo.length > 0 &&
                this.gruposEscopo.some(g => g.valores.length > 0);
            if (!temEscopoValido) {
                this.alertService.show('Atenção', 'Adicione ao menos um escopo com um valor antes de avançar.', AlertType.warning);
                return;
            }
            this.passo++;
        } else if (this.passo === 1) {
            this.step2.markAllAsTouched();
            if (this.step2.get('dataVigenciaInicio')?.value) {
                this.passo++;
            } else {
                this.alertService.show('Atenção', 'Informe a data de início da vigência antes de avançar.', AlertType.warning);
            }
        }
    }

    public voltar(): void {
        if (this.passo > 0) this.passo--;
    }

    /** Atalho pelo indicador de etapas: voltar é livre; avançar reusa a validação do avancar(), parando se bloquear. */
    public onPassoSelecionado(destino: number): void {
        if (destino === this.passo || destino < 0 || destino >= this.passos.length) return;
        if (destino < this.passo) {
            this.passo = destino;
            return;
        }
        while (this.passo < destino) {
            const atual = this.passo;
            this.avancar();
            if (this.passo === atual) return;
        }
    }

    // ── Datas de vigência (máscara + validação, padrão aba-movimentos) ──

    public onDateInput(event: Event): void {
        MaskService.onDateInput(event);
    }

    public onDateKeydown(event: KeyboardEvent): void {
        const teclasPermitidas = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'Enter'];
        const isAtalho = (event.ctrlKey || event.metaKey) && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase());
        if (teclasPermitidas.includes(event.key) || isAtalho) return;
        if (!/^\d$/.test(event.key)) {
            event.preventDefault();
        }
    }

    public onVigenciaBlur(event: FocusEvent, campo: 'inicio' | 'fim'): void {
        const input = event.target as HTMLInputElement;
        const control = campo === 'inicio' ? this.step2.get('dataVigenciaInicio') : this.step2.get('dataVigenciaFim');
        const valor = input?.value?.trim() || '';

        if (!valor) {
            this.atualizarCampoVigencia(campo, null);
            control?.markAsTouched();
            return;
        }

        const apenasNumeros = valor.replace(/\D/g, '').substring(0, 8);
        if (apenasNumeros.length !== 8) {
            input.value = '';
            this.atualizarCampoVigencia(campo, null);
            control?.markAsTouched();
            this.alertService.show('Atenção', 'Informe uma data válida no formato DD/MM/AAAA.', AlertType.warning);
            return;
        }

        const formatado = `${apenasNumeros.substring(0, 2)}/${apenasNumeros.substring(2, 4)}/${apenasNumeros.substring(4, 8)}`;
        input.value = formatado;

        const data = this.parseDataBr(formatado);
        if (!data) {
            this.atualizarCampoVigencia(campo, null);
            control?.markAsTouched();
            this.alertService.show('Atenção', 'Informe uma data válida no formato DD/MM/AAAA.', AlertType.warning);
            return;
        }

        this.atualizarCampoVigencia(campo, data);
        control?.markAsTouched();
        this.validarIntervaloVigencia();
    }

    public onVigenciaChange(campo: 'inicio' | 'fim', valor: Date | null): void {
        this.atualizarCampoVigencia(campo, valor);
        this.validarIntervaloVigencia();
    }

    private validarIntervaloVigencia(): void {
        const inicio = this.vigenciaInicioValue;
        const fim = this.vigenciaFimValue;
        if (inicio && fim && fim < inicio) {
            this.atualizarCampoVigencia('fim', null);
            this.alertService.show('Atenção', 'A data final da vigência não pode ser menor que a data de início.', AlertType.warning);
        }
    }

    private atualizarCampoVigencia(campo: 'inicio' | 'fim', data: Date | null): void {
        if (campo === 'inicio') {
            this.dataVigenciaInicio = data;
        } else {
            this.dataVigenciaFim = data;
        }
        this.sincronizarStep2Vigencia();
    }

    private sincronizarStep2Vigencia(): void {
        this.step2.patchValue({
            dataVigenciaInicio: this.dataVigenciaInicio,
            dataVigenciaFim: this.dataVigenciaFim,
        }, { emitEvent: false });
    }

    private parseDataBr(valor: string): Date | null {
        const partes = valor.split('/');
        if (partes.length !== 3) return null;
        const dia = Number(partes[0]);
        const mes = Number(partes[1]);
        const ano = Number(partes[2]);
        if (!Number.isInteger(dia) || !Number.isInteger(mes) || !Number.isInteger(ano)) return null;
        if (ano < 1000 || ano > 9999 || mes < 1 || mes > 12 || dia < 1 || dia > 31) return null;
        const data = new Date(ano, mes - 1, dia);
        data.setHours(0, 0, 0, 0);
        if (data.getFullYear() !== ano || data.getMonth() !== mes - 1 || data.getDate() !== dia) return null;
        return data;
    }

    public salvar(): void {
        this.step3.markAllAsTouched();
        const vigInicio = this.dataVigenciaInicio;
        if (!vigInicio) {
            this.passo = 1;
            this.step2.markAllAsTouched();
            this.alertService.show('Atenção', 'Informe a data de início da vigência.', AlertType.warning);
            return;
        }

        if (this.step3.get('cstIpi')?.invalid) {
            this.passo = 2;
            this.alertService.show('Atenção', 'Selecione o código de tributo da exceção.', AlertType.warning);
            return;
        }

        // sincronizarObrigatoriedade() marca como required os campos que o indicador do CST exige, inclusive a
        // escolha entre a alíquota e o valor por unidade; a seção marca o enquadramento.
        if (this.step3.invalid) {
            this.passo = 2;
            this.step3.markAllAsTouched();
            this.alertService.show('Atenção', 'Preencha os campos obrigatórios para o CST selecionado.', AlertType.warning);
            return;
        }

        const escopos: NaturezaOperacaoIpiExcecaoEscopoStruct[] = this.gruposEscopo.flatMap(g => {
            if (g.valores.length === 0) return [];
            return [{
                idExcecaoEscopo: this.data.excecaoData?.escopos.find(e => e.tipoEscopo === g.tipo)?.idExcecaoEscopo ?? null,
                tipoEscopo: g.tipo,
                valoresEscopo: g.valores.map(v => v.codigo),
            }];
        });

        const req: NaturezaOperacaoIpiExcecaoStruct = {
            nome:             this.gerarNome(),
            cstIpi:           this.step3.value.cstIpi ?? null,
            codigoEnquadramentoIpi: this.step3.value.codigoEnquadramentoIpi ?? null,
            pIpi:             this.step3.value.pIpi ?? null,
            vUnid:            this.step3.value.vUnid ?? null,
            observacao:       this.step3.value.observacao ?? null,
            observacaoFisco:  this.step3.value.observacaoFisco ?? null,
            dataVigenciaInicio:   this.formatarData(vigInicio),
            dataVigenciaFim:      this.dataVigenciaFim ? this.formatarData(this.dataVigenciaFim) : null,
            escopos,
            formulas:         this.estadosFormulas
                .filter(e => e.tipo !== TipoFormulaEnum.ModeloPadrao)
                .map(e => ({
                    chaveFormula: e.chaveFormula,
                    idFormulaPersonalizada: e.idFormulaPersonalizada ?? null,
                    tipo:               e.tipo,
                    chaveFormulaModelo:       e.chaveFormulaModelo ?? null,
                    expressao:          e.expressao ?? null,
                    tipoArredondamento: e.tipoArredondamento ?? null,
                    casasDecimais:       e.casasDecimais ?? null,
                    dataVigenciaInicio:     e.dataVigenciaInicio ?? null,
                    dataVigenciaFim:        e.dataVigenciaFim ?? null,
                })),
        };

        this.dialogRef.close({
            salvo: true,
            excecao: req,
            idExcecao: this.data.idExcecao ?? null,
        } as ExcecaoWizardDialogResult);
    }

    public fechar(): void {
        this.dialogRef.close(null);
    }

    // ── Privados ──────────────────────────────────────────────────────

    private gerarNome(): string {
        if (this.gruposEscopo.length === 0) return 'Exceção';
        const partes = this.gruposEscopo.map(g => {
            // Usa a descrição resolvida quando existir (ex.: "Simples Nacional"); nos escopos por
            // código (NCM/CEST/NBS/código de tributação nacional) a descrição já é o próprio código.
            const valores = g.valores.map(v => v.descricao || v.codigo).join(', ');
            return `${g.label}: ${valores}`;
        });
        return partes.join(' | ').substring(0, 120);
    }

    private reconstruirGrupos(escopos: NaturezaOperacaoIpiExcecaoEscopoStruct[]): EscopoGrupo[] {
        const mapa = new Map<TipoEscopoEnum, { codigo: string; descricao: string }[]>();
        for (const e of escopos) {
            if (!mapa.has(e.tipoEscopo)) mapa.set(e.tipoEscopo, []);
            for (const valor of e.valoresEscopo ?? []) {
                mapa.get(e.tipoEscopo)!.push({ codigo: valor, descricao: valor });
            }
        }

        const defsComContraparte = aplicarRotuloContraparte(GRUPOS_ESCOPO_DEF, this.data.tipoOperacao, this.tiposEscopoLabels);
        const grupos: EscopoGrupo[] = [];
        for (const g of defsComContraparte) {
            for (const t of g.tipos) {
                {
                    const novoGrupo: EscopoGrupo = {
                        tipo:      t.tipo,
                        label:     t.label,
                        grupo:     g.grupo,
                        labelGrupo: g.labelGrupo,
                        placeholder: t.placeholder,
                        valores:   mapa.get(t.tipo) ?? [],
                        valorNovo: '',
                    };
                    if (t.tipo === TipoEscopoEnum.Produto) {
                        novoGrupo.tempControl = new FormControl<any>(null);
                    }
                    if ([TipoEscopoEnum.UfOrigem, TipoEscopoEnum.UfDestino, TipoEscopoEnum.OrigemMercadoria, TipoEscopoEnum.TipoItem, TipoEscopoEnum.IndicadorInscricaoEstadual, TipoEscopoEnum.RegimeTrib, TipoEscopoEnum.TipoTributario].includes(t.tipo)) {
                        novoGrupo.tempControl = new FormControl<string[]>(novoGrupo.valores.map(v => v.codigo));
                    }
                    grupos.push(novoGrupo);
                }
            }
        }
        return grupos;
    }

    public onMultiSelectChange(grupo: EscopoGrupo, itens: any[]): void {
        grupo.valores = (itens ?? []).map(item => ({ codigo: String(item.id ?? item.codigo), descricao: item.descricaoExibicao ?? item.descricao }));
    }

    private atualizarDescricoesEscopo(tipo: TipoEscopoEnum, lista: Array<{ id?: string | number; codigo?: string; descricao: string }>): void {
        const grupo = this.gruposEscopo.find(item => item.tipo === tipo);
        if (!grupo) return;
        const descricoes = new Map(lista.map(item => [String(item.id ?? item.codigo), item.descricao]));
        grupo.valores = grupo.valores.map(valor => ({ ...valor, descricao: descricoes.get(valor.codigo) ?? valor.descricao }));
    }

    /** Resolve SKU/descrição dos produtos do escopo (persistidos por id) para exibir "SKU - Nome" ao editar. */
    private resolverProdutosEscopoBadges(): void {
        const grupo = this.gruposEscopo.find(g => g.tipo === TipoEscopoEnum.Produto);
        if (!grupo || grupo.valores.length === 0) return;
        const ids = grupo.valores.map(v => Number(v.codigo)).filter(n => Number.isFinite(n) && n > 0);
        if (ids.length === 0) return;

        this.produtoLookup.getAllSelectByIds(ids).subscribe(resp => {
            const mapa = new Map<string, { descricao: string; sku: string }>();
            (resp?.list ?? []).forEach(p => mapa.set(String(p.idProduto), {
                descricao: p.descricao ?? '',
                sku: p.codigoSku ?? '',
            }));
            grupo.valores = grupo.valores.map(v => {
                const info = mapa.get(v.codigo);
                return info ? { codigo: v.codigo, descricao: info.descricao || v.codigo, sku: info.sku } : v;
            });
        });
    }
    private formatarData(d: Date): string {
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    }
}
